export default {
  fa: {
    title: 'گزارش نوبت و سرویس\u200cها',
    hint: 'این گزارش فقط تلاش\u200cهای ثبت\u200cشده برای ارتباط با سرویس نوبت\u200cدهی را نشان می\u200cدهد.',
    from: 'از تاریخ',
    to: 'تا تاریخ',
    filter: 'نمایش گزارش',
    loading: 'در حال دریافت گزارش…',
    coverage: 'وضعیت داده\u200cها',
    conversion: 'نرخ تبدیل مسیر کاربر و تعداد نوبت\u200cهای موفق در این گزارش قابل محاسبه نیست.',
    responsesHint: 'دریافت پاسخ از سرویس به معنی ثبت موفق نوبت نیست. تلاش مجدد ممکن است چند بار شمرده شود.',
    refreshed: 'آخرین رویداد ثبت\u200cشده',
    unknown: 'نامشخص',
    reservation: 'درخواست رزرو',
    finalization: 'نهایی\u200cسازی',
    attemptsHint: 'تعداد تلاش\u200cها؛ نه تعداد افراد یا نوبت\u200cها',
    metric: 'شاخص',
    value: 'مقدار',
    attempts: 'تلاش\u200cهای ثبت\u200cشده',
    response: 'پاسخ دریافت\u200cشده',
    timeout: 'پایان مهلت پاسخ',
    unavailable: 'سرویس در دسترس نیست',
    rejected: 'درخواست ردشده',
    averageLatency: 'میانگین زمان پاسخ (میلی\u200cثانیه)',
    maxLatency: 'بیشترین زمان پاسخ (میلی\u200cثانیه)',
    empty: 'تلاشی در این بازه ثبت نشده است؛ این نتیجه نبود فعالیت واقعی را تأیید نمی\u200cکند.',
    daily: 'تلاش\u200cهای ثبت\u200cشده به تفکیک روز (UTC)',
    day: 'روز',
    stage: 'مرحله',
    outcome: 'نتیجه',
    disabled: 'ثبت داده‌های این گزارش غیرفعال است؛ نبود داده به معنی صفر بودن فعالیت نیست. مسئول فنی باید تنظیمات ثبت و نگهداری داده را بررسی کند. فعال‌سازی، سوابق نوبت‌های قبلی را بازیابی نمی‌کند.',
    notReady: 'گزارش هنوز آماده نیست؛ بعداً دوباره بررسی کنید.',
    partial: 'فقط تلاش\u200cهای مشاهده\u200cشده ثبت شده\u200cاند و کامل بودن داده\u200cها مشخص نیست.',
    forbidden: 'اجازهٔ مشاهدهٔ این گزارش را ندارید.',
    session: 'برای ادامه دوباره وارد شوید.',
    failed: 'دریافت گزارش ممکن نشد. دوباره تلاش کنید.',
    invalidRange: 'بازهٔ معتبر و حداکثر ۳۱ روزه انتخاب کنید.',
  },
  en: {
    title: 'Booking and service reports',
    hint: 'This report shows recorded attempts to contact the booking service only.',
    from: 'From',
    to: 'To',
    filter: 'Show report',
    loading: 'Loading report…',
    coverage: 'Data availability',
    conversion: 'Journey conversion and confirmed booking counts cannot be calculated from this report.',
    responsesHint: 'A provider response does not confirm a booking. Retries may be counted more than once.',
    refreshed: 'Last recorded event',
    unknown: 'Unknown',
    reservation: 'Reservation request',
    finalization: 'Finalization',
    attemptsHint: 'Attempt counts, not people or bookings',
    metric: 'Metric',
    value: 'Value',
    attempts: 'Recorded attempts',
    response: 'Response received',
    timeout: 'Response timed out',
    unavailable: 'Service unavailable',
    rejected: 'Request rejected',
    averageLatency: 'Average response time (ms)',
    maxLatency: 'Maximum response time (ms)',
    empty: 'No attempts were recorded in this range; this does not confirm no actual activity.',
    daily: 'Recorded attempts by UTC day',
    day: 'Day',
    stage: 'Stage',
    outcome: 'Outcome',
    disabled: 'Data collection for this report is disabled; missing data does not mean zero activity. Ask your technical administrator to check collection and retention settings. Enabling collection will not recover earlier booking records.',
    notReady: 'The report is not ready. Check again later.',
    partial: 'Only observed attempts are recorded; data completeness is unknown.',
    forbidden: 'You do not have permission to view this report.',
    session: 'Sign in again to continue.',
    failed: 'Could not load the report. Try again.',
    invalidRange: 'Choose a valid range of at most 31 days.',
  },
  ar: {
    title: 'تقارير الحجز والخدمات',
    hint: 'يعرض هذا التقرير محاولات الاتصال المسجلة بخدمة الحجز فقط.',
    from: 'من تاريخ',
    to: 'إلى تاريخ',
    filter: 'عرض التقرير',
    loading: 'جارٍ تحميل التقرير…',
    coverage: 'توفر البيانات',
    conversion: 'لا يمكن حساب معدل التحويل أو عدد الحجوزات المؤكدة من هذا التقرير.',
    responsesHint: 'استلام رد من الخدمة لا يؤكد الحجز. قد تُحسب إعادة المحاولة أكثر من مرة.',
    refreshed: 'آخر حدث مسجل',
    unknown: 'غير معروف',
    reservation: 'طلب حجز',
    finalization: 'إتمام الطلب',
    attemptsHint: 'عدد المحاولات، وليس الأشخاص أو الحجوزات',
    metric: 'المؤشر',
    value: 'القيمة',
    attempts: 'المحاولات المسجلة',
    response: 'تم استلام رد',
    timeout: 'انتهت مهلة الرد',
    unavailable: 'الخدمة غير متاحة',
    rejected: 'تم رفض الطلب',
    averageLatency: 'متوسط وقت الرد (مللي ثانية)',
    maxLatency: 'أطول وقت للرد (مللي ثانية)',
    empty: 'لم تُسجل محاولات في هذه الفترة؛ هذا لا يؤكد عدم وجود نشاط فعلي.',
    daily: 'المحاولات المسجلة حسب اليوم (UTC)',
    day: 'اليوم',
    stage: 'المرحلة',
    outcome: 'النتيجة',
    disabled: 'تسجيل بيانات هذا التقرير معطل؛ غياب البيانات لا يعني عدم وجود نشاط. اطلب من المسؤول التقني مراجعة إعدادات التسجيل والاحتفاظ بالبيانات. تفعيل التسجيل لن يسترجع سجلات الحجوزات السابقة.',
    notReady: 'التقرير غير جاهز بعد. تحقق لاحقًا.',
    partial: 'تُسجل المحاولات المرصودة فقط؛ اكتمال البيانات غير معروف.',
    forbidden: 'ليس لديك إذن لعرض هذا التقرير.',
    session: 'سجل الدخول مجددًا للمتابعة.',
    failed: 'تعذر تحميل التقرير. حاول مجددًا.',
    invalidRange: 'اختر فترة صالحة لا تتجاوز ٣١ يومًا.',
  },
}
